var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotahome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,350.000000) scale(0.100000,-0.100000)",
    fill: "#C9E3F7",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1645 2799 c-278 -40 -516 -253 -585 -525 -11 -43 -20 -94 -20 -115 l0 -38 403 -5 c221 -3 539 -8 706 -12 l304 -5 -6 73 c-27 317 -291 586 -617 628 -86 11 -103 11 -185 -1z M1032 1390 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z M2453 1375 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z M1041 1304 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z M2245 908 l-40 -43 43 40 c39 36 47 45 39 45 -2 0 -21 -19 -42 -42z M1230 916 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21 13z M1648 703 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z M1818 703 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,350.000000) scale(0.100000,-0.100000)",
    fill: "#FB6E44",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1044 2050 c13 -148 82 -300 186 -413 63 -70 175 -146 258 -177 62 -23 186 -50 233 -50 l29 0 0 355 0 355 -356 0 -357 0 7 -70z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,350.000000) scale(0.100000,-0.100000)",
    fill: "#FFCCEF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1031 2104 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z M1757 1773 c2 -191 3 -351 3 -355 0 -14 688 -10 692 4 8 23 -13 149 -36 218 -36 106 -81 175 -176 270 -121 122 -252 184 -425 204 l-60 7 2 -348z M1041 2014 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z M1648 1413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,350.000000) scale(0.100000,-0.100000)",
    fill: "#0A0777",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1044 1340 c15 -162 86 -310 206 -430 85 -85 156 -130 259 -166 256 -89 526 -32 722 153 122 116 205 283 216 436 l6 77 -708 0 -708 0 7 -70z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotahome);
export default __webpack_public_path__ + "static/media/spotahome.185e2d2ec13d96e818748dba2f83c667.svg";
export { ForwardRef as ReactComponent };